import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { api, formatApiError } from "../lib/api";
import { Save } from "lucide-react";

export default function Profile() {
  const { user, refresh } = useAuth();
  const [form, setForm] = useState({ name: "", picture: "", favorite_game: "", bio: "" });
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (user) {
      setForm({
        name: user.name || "",
        picture: user.picture || "",
        favorite_game: user.favorite_game || "EA FC 26",
        bio: user.bio || "",
      });
    }
  }, [user]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    setSaved(false);
    try {
      await api.put("/users/me", form);
      await refresh();
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-8 fade-in" data-testid="profile-page">
      <div>
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-primary">Profil</div>
        <h1 className="font-display text-4xl tracking-tight mt-2">Dein Profil</h1>
        <p className="text-white/60 text-sm mt-2">Aktualisiere deine persönlichen Informationen.</p>
      </div>

      <form onSubmit={save} className="card-solid p-6 max-w-2xl space-y-5">
        <div className="flex items-center gap-4">
          {form.picture ? (
            <img src={form.picture} alt="" className="w-16 h-16 object-cover rounded-sm border border-white/10" />
          ) : (
            <div className="w-16 h-16 bg-primary/10 border border-primary/30 text-primary flex items-center justify-center font-display text-2xl rounded-sm">
              {form.name?.[0]?.toUpperCase() || "?"}
            </div>
          )}
          <div>
            <div className="font-display text-lg">{user?.email}</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50">{user?.member_id} · {user?.role}</div>
          </div>
        </div>

        <div>
          <label className="label">Name</label>
          <input
            className="input"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            data-testid="profile-name-input"
          />
        </div>
        <div>
          <label className="label">Profilbild URL</label>
          <input
            className="input"
            placeholder="https://..."
            value={form.picture}
            onChange={(e) => setForm({ ...form, picture: e.target.value })}
            data-testid="profile-picture-input"
          />
        </div>
        <div>
          <label className="label">Lieblings-Game</label>
          <input
            className="input"
            value={form.favorite_game}
            onChange={(e) => setForm({ ...form, favorite_game: e.target.value })}
            data-testid="profile-game-input"
          />
        </div>
        <div>
          <label className="label">Bio</label>
          <textarea
            className="input"
            rows={3}
            value={form.bio}
            onChange={(e) => setForm({ ...form, bio: e.target.value })}
            data-testid="profile-bio-input"
          />
        </div>

        {error && <div className="text-sm text-red-400 font-mono">{error}</div>}
        {saved && <div className="text-sm text-accent font-mono" data-testid="profile-saved">Gespeichert ✓</div>}

        <button type="submit" disabled={saving} className="btn-primary" data-testid="profile-save-btn">
          <Save className="w-4 h-4" />
          {saving ? "Speichern…" : "Speichern"}
        </button>
      </form>
    </div>
  );
}
